import React from "react";
import { MapPin, Users, AlertTriangle, CheckCircle, Clock, DollarSign, Home, BarChart3 } from "lucide-react";

const InsightsTab = ({
  summaryOnly = false,
  insightsData = {
    individualNeeds: [],
    risksSearched: [],
    mostSearchedArea: "",
    timeToPlaceDays: 0,
    timeToCompleteReferralDays: 0,
    averageCostOfPlacement: 0,
    successfulPlacements: 0,
    totalPlacements: 0,
    timeToPlaceDifferenceFromLastMonth: 0,
    lastUpdated: null,
  },
}) => {
  // // Mock data - in a real app, this would come from API calls
  // const insightsDataMock = {
  //   mostSearchedArea: "Bristol City Centre",
  //   individualNeeds: [
  //     { name: "Autism Support", count: 45, percentage: 35 },
  //     { name: "Learning Disabilities", count: 32, percentage: 25 },
  //     { name: "Mental Health", count: 28, percentage: 22 },
  //     { name: "Physical Disabilities", count: 23, percentage: 18 },
  //   ],
  //   risksSearched: [
  //     { name: "Self-Harm Risk", count: 38, percentage: 30 },
  //     { name: "Substance Misuse", count: 25, percentage: 20 },
  //     { name: "Criminal Exploitation", count: 22, percentage: 17 },
  //     { name: "Gang Affiliation", count: 20, percentage: 16 },
  //     { name: "Missing from Care", count: 18, percentage: 14 },
  //     { name: "Sexual Exploitation", count: 5, percentage: 4 },
  //   ],
  //   // successfulMatches: 87,
  //   totalPlacements: 120,

  //   timeToCompleteReferral: "8.2 days",
  //   // dashboardUserRate: 94,
  //   averageCostPerPlacement: "£2,450",
  //   // averageDistanceFromHome: "15.2 miles"
  // };

  function totalIndividualNeedsSearches() {
    return insightsData?.individualNeeds.reduce((acc, need) => acc + need.count, 0);
  }

  function totalRisksSearched() {
    return insightsData?.risksSearched.reduce((acc, risk) => acc + risk.count, 0);
  }

  // const successRate = Math.round(
  //   (insightsData?.successfulMatches / insightsData?.totalPlacements) * 100
  // );

  return (
    <div className="insights-container">
      {/* Overview Cards */}
      <div className="row mb-2">
        <div className="col-md-4 mb-3">
          <div className="card h-100 insights-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="card-title mb-0">Successful Placements</h6>
                <CheckCircle className="text-success" size={20} />
              </div>
              <h3 className="mb-1">{insightsData?.successfulPlacements}</h3>
              <small className="text-muted">this month</small>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="card h-100 insights-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="card-title mb-0">Avg. Time to Place</h6>
                <Clock className="text-primary" size={20} />
              </div>
              <h3 className="mb-1">{insightsData?.timeToPlaceDays.toFixed(0)} days</h3>
              <small className="text-muted">
                {insightsData?.timeToPlaceDifferenceFromLastMonth > 0
                  ? `Up ${insightsData?.timeToPlaceDifferenceFromLastMonth} days from last month`
                  : `Down ${Math.abs(insightsData?.timeToPlaceDifferenceFromLastMonth).toFixed(
                      1
                    )} days from last month`}
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="card h-100 insights-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="card-title mb-0">Avg. Cost per Placement</h6>
                <DollarSign className="text-success" size={20} />
              </div>
              <h3 className="mb-1">£{insightsData?.averageCostOfPlacement.toFixed(0)}</h3>
              <small className="text-muted"> per month</small>
            </div>
          </div>
        </div>

        <div className="col-md-3 mb-3">
          {/* <div className="card h-100 insights-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="card-title mb-0">Dashboard Usage</h6>
                <BarChart3 className="text-info" size={20} />
              </div>
              <h3 className="mb-1">{insightsDataMock.dashboardUserRate}%</h3>
              <small className="text-muted">Daily active users</small>
            </div>
          </div> */}
        </div>
      </div>
      {/* Most Searched Area */}
      {!summaryOnly && (
        <div>
          <div className="card insights-card mb-4">
            <div className="card-header">
              <h5 className="card-title mb-1 d-flex align-items-center">
                <MapPin className="me-2 text-primary" size={20} />
                Most Searched Area of the Month
              </h5>
              <p className="card-text text-muted mb-0">
                Based on search activity within a 5-mile radius of your local authority
              </p>
            </div>
            <div className="card-body">
              <h2 className="text-primary mb-0">{insightsData?.mostSearchedArea}</h2>
              {/* <p className="text-muted mb-0">
                This area received the highest number of placement searches this month, indicating
                strong demand for placements in this location.
              </p> */}
            </div>
          </div>

          {/* Individual Needs and Risks */}
          <div className="row mb-4">
            {/* Individual Needs */}
            <div className="col-lg-6 mb-4">
              <div className="card insights-card h-100">
                <div className="card-header">
                  <h5 className="card-title mb-1 d-flex align-items-center">
                    <Users className="me-2 text-primary" size={20} />
                    Individual Needs Most Searched For
                  </h5>
                  <p className="card-text text-muted mb-0">
                    Top support needs requested in placement searches
                  </p>
                </div>
                {insightsData?.individualNeeds.length > 0 && (
                  <div className="card-body">
                  {insightsData?.individualNeeds.map((need, index) => (
                    <div key={index} className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span className="fw-medium">{need.name}</span>
                        <span className="text-muted small">{need.count} searches</span>
                      </div>
                      <div className="progress mb-1" style={{ height: "8px" }}>
                        <div
                          className="progress-bar bg-primary"
                          role="progressbar"
                          style={{
                            width: `${(need.count / totalIndividualNeedsSearches()) * 100}%`,
                          }}
                        ></div>
                      </div>
                      <small className="text-muted">{need.percentage}% of total searches</small>
                    </div>
                  ))}
                  </div>
                )}
                {insightsData?.individualNeeds.length === 0 && (
                  <div className="card-body">
                    <p className="text-muted mb-0">No individual needs searched for this month</p>
                  </div>
                )}
              </div>
            </div>

            {/* Risks */}
            <div className="col-lg-6 mb-4">
              <div className="card insights-card h-100">
                <div className="card-header">
                  <h5 className="card-title mb-1 d-flex align-items-center">
                    <AlertTriangle className="me-2 text-warning" size={20} />
                    Risks Most Searched For
                  </h5>
                  <p className="card-text text-muted mb-0">
                    Risk factors most commonly identified in placement searches
                  </p>
                </div>
                {insightsData?.risksSearched.length > 0 && (
                  <div className="card-body">
                  {insightsData?.risksSearched.map((risk, index) => (
                    <div key={index} className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span className="fw-medium">{risk.name}</span>
                        <span className="text-muted small">{risk.count} searches</span>
                      </div>
                      <div className="progress mb-1" style={{ height: "8px" }}>
                        <div
                          className="progress-bar bg-warning"
                          role="progressbar"
                          style={{ width: `${(risk.count / totalRisksSearched()) * 100}%` }}
                        ></div>
                      </div>
                      <small className="text-muted">{risk.percentage}% of total searches</small>
                    </div>
                  ))}
                  </div>
                ) }
                {insightsData?.risksSearched.length === 0 && (
                  <div className="card-body">
                    <p className="text-muted mb-0">No risks searched for this month</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Additional Metrics */}
          {/* <div className="row">
            <div className="col-md-6 mb-4">
              <div className="card insights-card h-100">
                <div className="card-header">
                  <h5 className="card-title mb-1 d-flex align-items-center">
                    <Clock className="me-2 text-primary" size={20} />
                    Time to Complete Referral
                  </h5>
                  <p className="card-text text-muted mb-0">
                    Average time from referral submission to completion
                  </p>
                </div>
                <div className="card-body">
                  <h2 className="text-primary mb-3">{insightsDataMock.timeToCompleteReferral}</h2>
                  <p className="text-muted mb-0">
                    This represents the average time taken to process and complete referrals, from
                    initial submission to final placement decision.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="card insights-card h-100">
                <div className="card-header">
                  <h5 className="card-title mb-1 d-flex align-items-center">
                    <Home className="me-2 text-primary" size={20} />
                    Distance from Home
                  </h5>
                  <p className="card-text text-muted mb-0">
                    How close to 'home' children have been placed
                  </p>
                </div>
                <div className="card-body">
                  <h2 className="text-primary mb-3">{insightsDataMock.averageDistanceFromHome}</h2>
                  <p className="text-muted mb-0">
                    Average distance between a child's home and their placement location. Lower
                    distances indicate better placement proximity to family and community.
                  </p>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default InsightsTab;